// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_TestClockChronologyRow.php
// Do not edit by hand — edit the PHP RowContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_TestClockChronologyRow — ONE cycle boundary an advance crossed,
 * and what the gateway door did about it (S11 · C2).
 *
 * The chronology is the clock's answer to "what did this advance actually
 * cause". It is deliberately per-BOUNDARY and not per-day: a boundary is the
 * only moment a real gateway has anything to say, and the whole conductor
 * exists to make those moments happen through the signed door instead of a
 * shortcut.
 *
 * A row is written for every boundary crossed, INCLUDING the ones that emitted
 * nothing. An empty chronology therefore means one specific thing — the advance
 * crossed no boundary at all — and never "something was emitted and we lost
 * track of it".
 *
 * outcome vocabulary (machine-readable; the C4 modal translates it):
 *   processed              the ingest ran and moved something.
 *   already_processed      a deterministic id this advance re-derived was
 *                          already delivered — the replay guard biting. NOT an
 *                          error: it is the clock's central guarantee.
 *   ignored                the delivery arrived and the pipeline classified it
 *                          as nothing to do (e.g. the confirm_delay_seconds
 *                          settlement window downgraded a confirmation).
 *   skipped:never_confirm  the simulator is in never_confirm mode, so no event
 *                          was emitted for this boundary at all.
 *   failed:<motivo>        the emission or the ingest refused. The shift is
 *                          permanent and already committed, so this is reported,
 *                          never rolled back, and later boundaries were still
 *                          attempted.
 *
 * event_type / event_id are null exactly when nothing was emitted
 * (skipped:never_confirm) — the two travel together and neither is ever
 * invented for display.
 *
 * boundary leaves as ISO-8601 UTC like every datetime on this wire. It is the
 * TRUE-frame instant (the boundary read with the accumulated offset added
 * back), which is why re-advancing over it re-derives the same event_id.
 *
 * ---------------------------------------------------------------------------
 * KIND (S11 · C3). A chronology is no longer only webhooks: after the C2
 * boundary entries, the advance appends one entry per REAL billing job it
 * fired (overdue_detection, then subscription_sweep — see
 * Test_clock::advance() for the order and why). `kind` tells the two shapes
 * apart; every field below `outcome` on a 'webhook' row and every job field
 * on a 'job' row are simply unused for the other kind, never invented.
 *
 * Old rows decoded from `subscription_test_clock_advances.chronology` (C2,
 * pre-C3) carry no `kind` key at all — the projection defaults a missing key
 * to 'webhook', which is exactly what every one of those rows is.
 *
 * job outcome vocabulary (distinct from the webhook vocabulary above):
 *   success               the job executor closed the run 'success'.
 *   failed                the executor closed 'failed' (or 'dead') — see
 *                          `summary` for the executor's own error string.
 *   skipped                the executor itself closed 'skipped'.
 *   skipped:job_not_seeded  no scheduled_jobs row exists for this job_type —
 *                          the clock does not create one.
 *   skipped:job_disabled   the row exists but staff disabled it — a human
 *                          decision the clock will never override.
 */
import { registerContract } from './validate'

export interface Subscriptions_TestClockChronologyRow {
kind?: string
boundary?: string
event_type?: string
event_id?: string
outcome?: string
detail?: string
job_type?: string
run_id?: number
summary?: string
}

registerContract('Subscriptions_TestClockChronologyRow', {
  kind:       { type: 'string',  required: false },
  boundary:   { type: 'string',  required: false },
  event_type: { type: 'string',  required: false },
  event_id:   { type: 'string',  required: false },
  outcome:    { type: 'string',  required: false },
  detail:     { type: 'string',  required: false },
  job_type:   { type: 'string',  required: false },
  run_id:     { type: 'number',  required: false },
  summary:    { type: 'string',  required: false },
})
